import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  Checkbox,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Dialog,
  ListItemText,
  InputLabel,
  Autocomplete,
  TextField,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";

import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import DatosBasicosApi from "api/datosbasicosApi";
import ProcesosApi from "api/procesosApi";

const NovedadesBandejaModal = ({ open, onClose, proceso }) => {
  const [error, setError] = useState(undefined);
  const [descNovedad, setDescNovedad] = useState("");
  const [tiposNovedad, setTiposNovedad] = useState([]);
  const [selectedTipo, setSelectedTipo] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [listaResponsables, setListaResponsables] = useState([]);
  const [novedades, setNovedades] = useState([]);
  const [descCausa, setDescCausa] = useState("");
  //let user = localStorage.getItem("user");
  //user = JSON.parse(user);
  useEffect(() => {
    if (proceso) {
      const fetchInitialData = async () => {
        try {
          const [tiposNovedadRes, responsablesRes] = await Promise.all([
            DatosBasicosApi.fetchTiposNovedad(),
            ProcesosApi.fetchResponsables({ roles: ["TODOS"] }),
          ]);
          setTiposNovedad(tiposNovedadRes.data);
          setUsuarios(responsablesRes.data);
        } catch (error) {
          console.error("Error al obtener los datos iniciales:", error);
          setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
        }
      };

      fetchInitialData();
    }
  }, [proceso]);

  const fetchNovedades = async () => {
    if (proceso) {
      try {
        const response = await ProcesosApi.fetchNovedades({ id_proceso: proceso.id });
        setNovedades(response.data);
      } catch (error) {
        console.error("Error al obtener las Novedades:", error);
        setError(obtenerMensajeError(error, "Error al obtener las Novedades."));
      }
    }
  };

  useEffect(() => {
    if (proceso) {
      fetchNovedades();
    }
  }, [proceso]);

  const hCDescripcion = (event) => {
    //console.log("hCDescripcion.value: " + JSON.stringify(event.target.value));
    setDescNovedad(event.target.value);
  };

  const handleResponsablesChange = (event) => {
    const selectedIds = event.target.value; // Array de IDs seleccionados
    // Filtra usuarios para obtener los objetos completos de los IDs seleccionados
    const selectedUsers = usuarios.filter((user) => selectedIds.includes(user.id));
    setListaResponsables(selectedUsers);
  };

  const hCCausa = (event) => {
    //console.log("hCCausa.value: " + JSON.stringify(event.target.value));
    setDescCausa(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones
    if (selectedTipo == null) {
      setError("Debes seleccionar un Tipo de Novedad.");
      return;
    }
    if (descNovedad === "") {
      setError("Debes registrar una Descripción y una Causa.");
      return;
    }
    const datos = {
      operacion: "NOVEDAD",
      id_proceso: proceso.id,
      tipo_novedad: selectedTipo,
      desc_seguimiento: descNovedad,
      lista_involucrados: listaResponsables.map((user) => user.id),
      desc_causa: descCausa,
    };
    //console.log("SEGUIMIENTO.datos: " + JSON.stringify(datos));
    try {
      //console.log("proceso: " + proceso);
      const response = await ProcesosApi.operarProceso(datos);
      if (response.status === 201 && response.data) {
        alert("Operación realizada con éxito");
        setError(undefined);
        setDescNovedad("");
        setDescCausa("");
        setListaResponsables([]);
        setSelectedTipo(null);
        fetchNovedades();
      }
      //onSuccess();
    } catch (error) {
      console.error("Error al registrar la Novedad:", error);
      setError(obtenerMensajeError(error, "Error al registrar la Novedad."));
    }
  };

  const hCClose = () => {
    setError(undefined);
    setDescNovedad("");
    setDescCausa("");
    setListaResponsables([]);
    setSelectedTipo(null);
    onClose();
  };

  const hcValidarNovedad = async (novedad) => {
    //console.log("novedad: " + JSON.stringify(novedad));
    const confirmAction = window.confirm(`¿Estás seguro(a) que deseas validar la Novedad?`);
    if (confirmAction) {
      const datos = {
        operacion: "VALIDAR_NOVEDAD",
        id_novedad: novedad,
      };
      try {
        const response = await ProcesosApi.operarNovedad(datos);
        if (response.status === 201 && response.data) {
          // Aquí podrías actualizar el estado local para reflejar el cambio en la UI o recargar los datos.
          alert("Novedad VALIDADA con exito.");
        }
      } catch (error) {
        alert(obtenerMensajeError(error, "Error"));
      }
    }
  };

  const hcAceptarNovedad = async (novedad) => {
    const confirmAction = window.confirm(`¿Estás seguro(a) que deseas aceptar la Novedad?`);
    if (confirmAction) {
      const datos = {
        operacion: "ACEPTAR_NOVEDAD",
        id_novedad: novedad,
      };
      try {
        const response = await ProcesosApi.operarNovedad(datos);
        if (response.status === 201 && response.data) {
          // Aquí podrías actualizar el estado local para reflejar el cambio en la UI o recargar los datos.
          alert("Novedad ACEPTADA con exito.");
        }
      } catch (error) {
        alert(obtenerMensajeError(error, "Error"));
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <h3>REGISTRAR NOVEDAD</h3>
        <strong>PROCESO: {proceso ? proceso.identificador : "No tiene Proceso"}</strong>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Tipo Novedad *</InputLabel>
                <Autocomplete
                  disablePortal
                  options={tiposNovedad}
                  getOptionLabel={(option) => option.nombre}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={selectedTipo}
                  onChange={(_, newValue) => setSelectedTipo(newValue)}
                />
              </SuiBox>
            </Grid>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Lista Involucrados</InputLabel>
                <Select
                  multiple
                  value={listaResponsables.map((user) => user.id)} // Usar IDs para el control del valor
                  onChange={handleResponsablesChange}
                  renderValue={(selected) =>
                    selected
                      .map((id) => usuarios.find((user) => user.id === id)?.nombre_completo)
                      .join(", ")
                  }
                >
                  {usuarios.map((usuario) => (
                    <MenuItem key={usuario.id} value={usuario.id}>
                      <Checkbox
                        checked={listaResponsables.some((item) => item.id === usuario.id)}
                      />
                      <ListItemText primary={usuario.nombre_completo} />
                    </MenuItem>
                  ))}
                </Select>
              </SuiBox>
            </Grid>
          </Grid>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Descripción *</InputLabel>
                <SuiInput
                  value={descNovedad}
                  placeholder="Descripción"
                  multiline
                  rows={5}
                  onChange={hCDescripcion}
                />
              </SuiBox>
            </Grid>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Causa</InputLabel>
                <SuiInput
                  value={descCausa}
                  placeholder="Causa"
                  multiline
                  rows={5}
                  onChange={hCCausa}
                />
              </SuiBox>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            Registrar
          </SuiButton>
        </DialogActions>

        {/* Sección de Novedades */}
        <DialogContent>
          <SuiBox mt={4}>
            <strong>
              Novedades del Proceso: {proceso ? proceso.identificador : "No tiene Proceso"}
            </strong>
          </SuiBox>
          <SuiBox mt={2}>
            {novedades.length > 0 ? (
              novedades.map((novedad, index) => (
                <SuiBox
                  key={index}
                  p={2}
                  mb={2}
                  border={1}
                  borderColor="grey.300"
                  borderRadius="2px"
                  bgcolor="grey.100"
                >
                  <SuiBox display="flex" justifyContent="space-between">
                    <strong>
                      {novedad.consecutivo} - {novedad.tipo_novedad_detalle.nombre}
                    </strong>
                    <span>{novedad.estado_novedad}</span>
                    <span>
                      {!novedad.validada && (
                        <IconButton
                          title="VALIDAR NOVEDAD"
                          onClick={() => hcValidarNovedad(novedad.id)}
                        >
                          <CheckCircleIcon color="success" fontSize="large" />
                        </IconButton>
                      )}
                      {novedad.validada && !novedad.aceptada && (
                        <IconButton title="ACEPTAR" onClick={() => hcAceptarNovedad(novedad.id)}>
                          <DoneAllIcon color="secondary" fontSize="large" />
                        </IconButton>
                      )}
                    </span>
                  </SuiBox>
                  <SuiBox mt={1}>
                    <strong>Descripción:</strong> {novedad.descripcion}
                  </SuiBox>
                  <SuiBox mt={1}>
                    <strong>Causa:</strong> {novedad.causa}
                  </SuiBox>
                  <SuiBox mt={1}>
                    <strong>Involucrados:</strong>{" "}
                    {novedad.lista_involucrados.length > 0
                      ? novedad.lista_involucrados_detalle
                          .map((usuario) => usuario.nombre_completo)
                          .join(", ")
                      : "No tiene involucrados."}
                  </SuiBox>
                </SuiBox>
              ))
            ) : (
              <Alert severity="info">No hay novedades registradas.</Alert>
            )}
          </SuiBox>
        </DialogContent>
      </form>
    </Dialog>
  );
};

NovedadesBandejaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  proceso: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default NovedadesBandejaModal;
